import {isFeatureEnabled} from 'feature-flags';
import {openDialog} from 'platform/components';

import {featureFlags} from '@dms/feature-flags';

import {BulkOperationResultDialogContent} from '../components/BulkOperationResultDialogContent/BulkOperationResultDialogContent';

export function openBulkOperationResultDialog(bulkOperationId: string, actionLabel?: string) {
  if (!isFeatureEnabled(featureFlags.DATA_GRID_BULK_OPERATIONS)) {
    return;
  }
  openDialog(
    <BulkOperationResultDialogContent
      bulkOperationId={bulkOperationId}
      actionLabel={actionLabel}
    />,
    {id: `bulkOperationResult-${bulkOperationId}`, size: 'default', withAdditionalFooter: true}
  );
}
